import React, { useCallback, useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Trash2Fill } from '@lyearn/icons';
import { AlertDialog } from '@lyearn/molecules';
import { useSnackbar } from '@lyearn/ui';
import useNavigation from '@/hooks/useNavigation';
import useResponse from '@/hooks/useResponse';
import routes from '@/pages/corporate/routes';

import useFileMutations from '../../../hooks/useFileMutations';
import { DialogProps } from '../types';

function DeleteList({ fileId, onClose, inViewFileId }: DialogProps) {
  const { t } = useTranslation();
  const [isFetching, setIsFetching] = useState(false);
  const { deleteFile } = useFileMutations();
  const { showSnackbar } = useSnackbar();
  const { handleResponse } = useResponse();
  const navigation = useNavigation();

  const onDelete = useCallback(async () => {
    if (!fileId) return;
    setIsFetching(true);
    const data = await deleteFile({
      data: {
        fileId,
      },
    });
    setIsFetching(false);

    handleResponse({
      condition: !!data.data?.deleteFile?.success,
      onSuccess: () => {
        showSnackbar({
          message: 'List deleted successfully',
          startIcon: <Trash2Fill fillColorToken="icon-placeholder" />,
        });

        onClose();
        if (inViewFileId === fileId) {
          navigation.replace(routes.Tasks(), {
            appendQuery: false,
          });
        }
      },
    });
  }, [deleteFile, fileId, handleResponse, inViewFileId, navigation, onClose, showSnackbar]);

  return (
    <AlertDialog
      header={{
        title: 'Delete List?',
        description: '',
      }}
      primaryAction={{
        appearance: 'danger',
        label: t('Common:Actions.Delete'),
        onClick: onDelete,
        disabled: isFetching,
        loading: isFetching,
      }}
      onClose={onClose}
    />
  );
}

export default DeleteList;
